import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { styled } from '@mui/material/styles';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  FormControlLabel,
} from '@mui/material';
// components
import Iconify from './iconify';
import Scrollbar from './scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
import HunterForDog from './HunterForDog';

const TABLE_HEAD = [
  { id: 'id', label: 'Broj', alignRight: false },
  { id: 'tip', label: 'Tip', alignRight: false },
  { id: 'subscriber', label: 'Vlasnik', alignRight: false, sortable: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'tiptrackera', label: 'Tip trackera', alignRight: false },
  { id: 'IMEI', label: 'IMEI', alignRight: false },
  { id: 'aktivan', label: 'Aktivan', alignRight: false },
  { id: 'online', label: 'Online', alignRight: false },
  { id: 'onlinetoday', label: 'Online danas', alignRight: false },
  { id: 'datumlast', label: 'Datum last', alignRight: false },
  { id: 'datumend', label: 'Datum end', alignRight: false },
  { id: 'saldo', label: 'Saldo', alignRight: false },
  { id: 'history', label: 'History', alignRight: false, sortable: false },
  { id: 'analize', label: 'Analize', alignRight: false, sortable: false },
];

// Kuda vode linkovi u redu
const HISTORY_URL = '/dashboard/HistoryActiveDates';
const ANALIZE_URL = '/dashboard/HistoryAnalyse'; // stranica za analize još ne postoji

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  const sorted = stabilizedThis.map((el) => el[0]);
  if (query) {
    return filter(sorted, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return sorted;
}

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update state to force render
}

// Stilizovani switch za Online / Online danas (definisan jednom, izvan komponente)
const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export default function HistoryHuntersDevices(props) {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [devices, setDevices] = useState([]);

  const [loadedSubscriberId, setLoadedSubscriberId] = useState(0);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showDeviceCreate, setShowDeviceCreate] = useState(false);

  const forceUpdate = useForceUpdate();

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const handleChangeAktivan = (event, deviceId) => {
    const lista = devices;

    const device = lista.find((obj) => obj.id === deviceId);

    axios
      .put(`${SERVER_URL}/devices/${deviceId}`, {
        aktivan: !device.aktivan,
      })
      .then(() => {
        device.aktivan = !device.aktivan;

        setDevices(lista);
        forceUpdate();
      });
  };

  const handleDeviceCreated = () => {
    setShowDeviceCreate(!showDeviceCreate);
    refreshData();
  };

  function refreshData() {
    const url = `${SERVER_URL}/devices?subscriberId=${props.vlasnik}`;

    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        setLoadedSubscriberId(props.vlasnik);
        setDevices(json);
        // Novi vlasnik ili osvježeni podaci: vrati na prvu stranicu ako trenutna više ne postoji
        setPage((p) => (p * rowsPerPage >= json.length ? 0 : p));
      });
  }

  if (loadedSubscriberId !== props.vlasnik) refreshData();

  // Podaci o uređaju za stranice History i Analize (čitaju ih iz localStorage)
  const sacuvajUredjaj = (device) => {
    const { id, IMEI, ime, tip, tiptrackera, onlinetoday, subscriber } = device;
    localStorage.setItem('id', id);
    localStorage.setItem('IMEI', IMEI);
    localStorage.setItem('ime', ime);
    localStorage.setItem('tip', tip);
    localStorage.setItem('tiptrackera', tiptrackera);
    localStorage.setItem('onlinetoday', onlinetoday);
    localStorage.setItem('subscriberime', subscriber?.ime ?? '');
    localStorage.setItem('subscriberprezime', subscriber?.prezime ?? '');
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - devices.length) : 0;

  const filteredDevices = applySortFilter(devices, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredDevices.length && !!filterName;

  const ukupnoKolona = TABLE_HEAD.length;

  return (
    <>
      <Helmet>
        <title> GPS Dogs Tracking System </title>
      </Helmet>

      <Container maxWidth={false}>
        <Button onClick={() => setShowDeviceCreate(!showDeviceCreate)}>Dodaj uređaj</Button>
        {showDeviceCreate && <HunterForDog hunterId={props.vlasnik} handler={handleDeviceCreated} className="child" />}

        <Card>
          {devices.length > 0 ? (
            <>
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead order={order} orderBy={orderBy} headLabel={TABLE_HEAD} onRequestSort={handleRequestSort} />
                    <TableBody>
                      {filteredDevices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const {
                          id,
                          ime,
                          tip,
                          IMEI,
                          tiptrackera,
                          aktivan,
                          online,
                          onlinetoday,
                          datumend,
                          saldo,
                          datumlast,
                          subscriber,
                        } = row;

                        return (
                          <TableRow hover key={id} tabIndex={-1}>
                            <TableCell component="th" scope="row">
                              <Typography variant="subtitle2" noWrap>
                                {id}
                              </Typography>
                            </TableCell>

                            <TableCell>
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar
                                  alt={ime}
                                  src={tip ? `/assets/images/lovackipsi/icon_${tip}.png` : undefined}
                                  sx={{ width: 50, height: 50 }}
                                  variant="rounded"
                                >
                                  <Iconify icon="mdi:paw" width={28} />
                                </Avatar>
                                <Avatar
                                  alt={tiptrackera}
                                  src={
                                    tiptrackera
                                      ? `/assets/images/trackers/icon_${tiptrackera.toLowerCase()}.png`
                                      : undefined
                                  }
                                  sx={{ width: 30, height: 30 }}
                                  variant="rounded"
                                >
                                  <Iconify icon="mdi:crosshairs-gps" width={18} />
                                </Avatar>
                              </Stack>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {subscriber?.ime} {subscriber?.prezime}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {ime}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {tiptrackera}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {IMEI}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Checkbox
                                color="success"
                                checked={Boolean(aktivan)}
                                onChange={(event) => handleChangeAktivan(event, id)}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                            </TableCell>

                            <TableCell>
                              <FormControlLabel control={<Android12Switch checked={Boolean(online)} />} label="" />
                            </TableCell>

                            <TableCell>
                              <FormControlLabel control={<Android12Switch checked={Boolean(onlinetoday)} />} label="" />
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {datumlast}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {datumend}
                              </Typography>
                            </TableCell>

                            <TableCell align="left">
                              <Typography variant="subtitle2" noWrap>
                                {saldo}
                              </Typography>
                            </TableCell>

                            <TableCell>
                              <Link to={HISTORY_URL}>
                                <Button onClick={() => sacuvajUredjaj(row)}>History</Button>
                              </Link>
                            </TableCell>

                            <TableCell>
                              <Link to={ANALIZE_URL}>
                                <Button onClick={() => sacuvajUredjaj(row)}>Analize</Button>
                              </Link>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={ukupnoKolona} />
                        </TableRow>
                      )}
                    </TableBody>

                    {isNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={ukupnoKolona} sx={{ py: 3 }}>
                            <Paper sx={{ textAlign: 'center' }}>
                              <Typography variant="h6" paragraph>
                                Nema rezultata
                              </Typography>
                              <Typography variant="body2">
                                Ništa nije pronađeno za &nbsp;
                                <strong>&quot;{filterName}&quot;</strong>.
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredDevices.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          ) : (
            <div>
              <br /> Korisnik nema uređaja
            </div>
          )}
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}